module.exports = __webpack_public_path__ + "images/touch-icon-iphone-retina.5b500f9e961e0d1d1347ff8e2f5b1b0a.png";